export default {"src":"/_next/static/media/mode_computer_hard.ccf1b483.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};